
import { Component, Prop, Vue } from "vue-property-decorator"
import { VueLoading } from "vue-loading-template"

@Component({
  components: { VueLoading },
})
export default class Loading extends Vue {
  @Prop()
  private loading!: boolean
}
